<template>
  <v-form ref="cashiersForm">
    <v-row>
      <v-col cols="12" md="12">
        <p class="text-h6">Informacion General</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-text-field
          v-model="data.dscr"
          label="Concepto"
          outlined
          dense
          required
        ></v-text-field>
        <v-text-field
          v-model="data.code"
          label="Código"
          outlined
          dense
          required
        ></v-text-field>
        <v-autocomplete
          outlined
          dense
          v-model="data.ctgr"
          label="Categoría del servicio"
          :items="Categories"
          item-value="id"
          item-text="Nombre"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
        >Guardar</v-btn
      >
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import Currency from "../../../clases/Currencies.js";
import PeriodosCobro from "../../../clases/Membresias/PeriodosCobro.js";
import { mapActions } from "vuex";

export default {
  name: "ConceptoForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      currencyClass: Currency,
      monedas: [],
      data: {
        dscr: "",
        code: "",
        ctgr: "",
      },
      rules: {},
      Categories: [],
      tiposPagos: {},
    };
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    checkForm() {
      if (this.$refs.cashiersForm.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    async getCategories() {
      this.Categories = await this.fetchCategories();
    },
    send(action) {
      let dataSave = this.data;
      dataSave.Pagos = Number(dataSave.Pagos);
      dataSave.Prorroga = Number(dataSave.Prorroga);
      dataSave.Periodos = Number(12 / dataSave.Pagos);
      if (action === "EDIT") {
        // id de edicion
        dataSave.Id = this.dataEdit.id;
      }
      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    this.getCategories();
    //localStorage.getItem("selectedDepartment");
    if (this.edit) {
      this.data = this.dataEdit;
      /*(this.data.Nomb   = this.dataEdit.Nomb),
      (this.data.Activo = this.dataEdit.Activo),
      (this.data.CA.C   = this.dataEdit.CA.C),
      (this.data.CA.M   = this.dataEdit.CA.M),
      (this.data.CPA.C  = this.dataEdit.CPA.C),
      (this.data.NM  = this.dataEdit.NM),
      (this.data.CPA.M  = this.dataEdit.CPA.M);
      (this.data.TIA  = this.dataEdit.TIA);
      (this.data.Cve  = this.dataEdit.Cve);*/
    }
  },
};
</script>
